import { axios, toCamelCase } from '@utils';

const BASE_URL = '/api/v1/legup/coupons';
async function fetchWaitlistCoupons(providerId) {
  const response = await axios.get(`${BASE_URL}/provider_waitlist_coupons.json?provider_id=${providerId}`);
  return toCamelCase(response.data);
}

async function createWaitlistCoupon(providerId, params) {
  const response = await axios.post(`${BASE_URL}.json?provider_id=${providerId}`, params);
  return toCamelCase(response.data);
}

async function updateWaitlistCoupon(providerId, couponId, params) {
  const response = await axios.put(`${BASE_URL}/${couponId}.json?provider_id=${providerId}`, params);
  return toCamelCase(response.data);
}

export {
  fetchWaitlistCoupons,
  createWaitlistCoupon,
  updateWaitlistCoupon,
};
